import React, { useContext, useEffect, useMemo } from 'react'
import {
    Route,
    BrowserRouter as Router,
    withRouter,
    Switch,
} from 'react-router-dom'
import PrivateRoute from './privateRoute'
import Coupon from '@/views/Coupon'
// import Coupon from '@/product/customViews/Coupon'
import GiftCard from '@/product/customViews/GiftCard'
import Dashboard from '@/views/Dashboard'
// import Dashboard from '@/product/customViews/Dashboard'
// import Profile from '@/product/customViews/Profile'
import Profile from '@/views/Profile'

import AuctionLots from '../product/customViews/AuctionLots/dynamic'
// import PayOut from '../product/customViews/PayOut'
import StripeStatusCheck from '../product/customViews/PayOut/statusCheck'
import Report from '@/views/Report'
import Login from '@/views/Login'
// import Login from '../product/customViews/Login'
import Listing from '../views/Listing/dynamic'
import BidDeposit from '../product/customViews/BidDeposit'
import UserView from '../views/UserManagement/UserView'
import BuyerFields from '../views/UserManagement/BuyerFields'
import Employee from '../views/EmployeeManagement/index'
import TemplateView from '../product/views/Communications/TemplateView'
import StaticView from '../product/customViews/Settings/StaticView'
import BroadCaster from '../product/customViews/VideoAuction/BroadCaster'
// import Return from '@/views/Return/index'
import Return from '../product/customViews/Return'
import ReturnView from '../product/customViews/Return/view'
import Inventory from '@/views/Inventory'
import QuestionAnswer from '../product/customViews/Comments/index'
import EmailLogs from '../product/views/Communications/EmailLogs'
import Invoice from '../views/Invoice/index'
import Payment from '../product/customViews/Payment'
import LanguageManager from '../product/customViews/LanguageManager'
import StaticPages from '../product/customViews/Settings/StaticPages'
import ConfigView from '@/views/Settings/ConfigView'
import MaintanenceManage from '../product/views/Settings/Maintanence/MaintanenceManage'
import ChangePassword from '@/product/views/ChangePassword'
import AuthContext from '@/product/context/auth/authContext'
import CustomCommonContext from '../custom/context/common/commonContext'
import ProductCommonContext from '@/product/context/common/commonContext'
import Category from '../views/Settings/Category'
import Condition from '../views/Settings/Condition'
// import Location from '../product/customViews/Settings/Location'
import Location from '../views/Location/Location'
import OrgView from '../views/Organization/OrgView'
import CreateCampaign from '../product/customViews/Campaign/CreateCampaign'
import EmailTemplate from '../product/customViews/Campaign/EmailTemplate'
import Wallet from '../product/customViews/Wallet'
import SubscribeData from '../product/customViews/subscribe'
import TransactionPayment from '@/views/Transaction/payment'
import TransactionRefund from '../product/customViews/Transaction/refund'
import Appointment from '../product/customViews/Appointment'
import MemberItemLookUp from '@/views/Return/Member/index'
import BidIncrement from '@/views/Settings/BidIncrement/index'
import LiveAuction from '../product/customViews/VideoAuction/LiveAuction'
import SettingsUI from '../product/customViews/SettingsUI'
import DynamicPage from '../product/customViews/Dynamic/pages'
import TaxCodeList from '../product/customViews/Settings/TaxCodeList'
import DynamicTablePages from '@/product/views/DynamicTable/pages'
import Message from '../product/customViews/Message'
// import Order from '../product/customViews/Order'
import Order from '../views/Order'
// import ERP from '../product/customViews/ERP'
import ERP from '@/views/ERP/index'
import InventoryErp from '@/views/ERP/Inventory'
// import InventoryErp from '@/product/customViews/ERP/Inventory'
import Manifest from '@/product/customViews/ERP/Manifest'
import Plugins from '@/product/views/Plugins'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import PalletPricing from '../product/customViews/Settings/PalletPricing'
// import MyCard from '../product/customViews/MyPayments/MyCards'
import AuctionTemplates from '../product/customViews/Template/Auction/dynamic'
import ProductTemplates from '../product/customViews/Template/Product/dynamic'
import BannerImage from '@/views/Settings/BannerImage'
// import BannerImage from '../product/customViews/Settings/BannerImage'
import TwoFactor from '../product/customViews/Settings/TwoFactor'
import BillingInfo from '../product/views/MyPayments'
import MyInvoice from '../product/views/MyInvoice'
// import EditListing from '@/product/components/organisms/Customized/Listing/Tabs/EditListing'
import EditListing from '@/custom/components/organisms/Customized/Listing/Tabs/EditListing'
import InvoiceView from '../views/Invoice/view'
import ProductTemplateManage from '../product/customViews/Template/Product/dynamicListing'
import Logs from '../product/customViews/Logs'
// import ManageComments from '../product/customViews/Comments/manageComments'
import ManageComments from '@/views/Comments/manageComments'
import EmployeeView from '../product/customViews/EmployeeManagement/edit'
import AuctionTemplateManage from '../product/customViews/Template/Auction/dynamicListing'
import EmployeeEdit from '../views/EmployeeManagement/edit'
import EmployeeManage from '../views/EmployeeManagement/view'
import OrgManage from '../views/Organization/OrgManage'
import UserManage from '../views/UserManagement/dynamicUser'
import InitialPublicFunction from '@/views/InitialFunction/public'
import AuctionListing from '../product/customViews/AuctionLots/dynamicListing'
import Theme from '../product/customViews/Store/Theme'
import ListingManage from '../views/Listing/newListing'
import AgencyView from '@/product/customViews/AgencyManagement'
import AllAgencyUsers from '@/product/customViews/AgencyManagement/AgencyUsers'
import AgencyPayment from '@/product/customViews/AgencyManagement/payment'
import SchedulePickUp from '@/views/SchedulePickUp'
import PaymentManage from '@/product/customViews/Invoice/PaymentManage'
import ForgotPassword from '@/product/customViews/ForgotPassword'
import ResetPassword from '@/product/customViews/ResetPassword'
import InitialFunction from '@/product/views/InitialFunction'
import SwitchUser from '@/product/views/SwitchUser'
import HeaderMenu from '@/views/Settings/HeaderMenu'
import TaxTable from '@/views/Settings/TaxTable'
import UserAdd from '@/views/UserManagement/UserAdd'
import DraftListing from '@/views/Listing/Draft/index'
import Syncinventory from '@/views/Listing/SyncInventory'
import Transaction from '@/views/Transaction/payment'
import TransactionZb from '@/views/Transaction/paymentZb'
import ManualTransfer from '@/views/Transaction/ManualTransfer'
import ManualTransferZb from '@/views/Transaction/ManualTransferZb'
import PayOut from '../product/customViews/PayOut'
import NotFound from '@/views/NotFound'

const Routes = () => {
    const { loadUser, user } = useContext(AuthContext)
    const { getAllCountries, getAllStates } = useContext(ProductCommonContext)
    const { getGlobalVariable } = useContext(CustomCommonContext)
    const { getAllDynamicFields, getAllDynamicTables } =
        useContext(DynamicContext)
    useEffect(() => {
        if (localStorage.token) {
            loadUser()
        }
    }, [])

    const extraBannerFields = useMemo(
        () => [
            {
                label: 'Event Date',
                type: 'text',
                placeholder: 'Enter the Event Date',
                class: 'col-sm-6 col-12',
                name: 'event_date',
                isRequired: false,
            },
        ],
        []
    )

    return (
        <>
            <InitialPublicFunction
                global={true}
                countries={true}
                states={true}
                cities={false}
            />
            {localStorage.token ? <InitialFunction /> : null}
            <Switch>
                {/* <Route exact path="/" component={Login} /> */}
                <Route
                    exact
                    path="/"
                    render={(props) => (
                        <Login {...props} enableAutofillCheck={true} />
                    )}
                />
                <Route exact path="/switch" component={SwitchUser} />
                <PrivateRoute exact path="/gift_card">
                    <GiftCard noExpiry={true} />
                </PrivateRoute>
                <PrivateRoute
                    exact
                    path="/registration_coupon"
                    component={Coupon}
                />
                <PrivateRoute
                    exact
                    path="/zb/zp/transfer"
                    component={ManualTransferZb}
                />
                <Route
                    exact
                    path="/forgot_password"
                    render={(props) => (
                        <ForgotPassword
                            {...props}
                            onSuccess={true}
                            onError={true}
                        />
                    )}
                    // component={ForgotPassword}
                    // onSuccess={true}
                    // onError={true}
                />
                <Route
                    exact
                    path="/reset_password/:token"
                    component={ResetPassword}
                />
                <PrivateRoute
                    exact
                    path="/change_password"
                    component={ChangePassword}
                />
                <PrivateRoute exact path="/profile" component={Profile} />
                <PrivateRoute
                    exact
                    path="/seller_payout/transaction"
                    component={Transaction}
                />
                <PrivateRoute
                    exact
                    path="/zb/zp_transaction"
                    component={TransactionZb}
                />
                <PrivateRoute
                    exact
                    path="/seller_payout/:action"
                    component={ManualTransfer}
                />

                {/* <PrivateRoute exact path="/dashboard" component={Dashboard} /> */}
                <Route
                    exact
                    path="/dashboard"
                    render={(props) => (
                        <Dashboard
                            {...props}
                            quickAccess={true}
                            auctionTitle={'Single Listing Inventory'}
                            draftInventory={'Draft Inventory'}
                            memberLookUp={'Member & Item LookUp'}
                        />
                    )}
                />
                <PrivateRoute
                    exact
                    path="/schedulepickup"
                    component={SchedulePickUp}
                />
                <PrivateRoute
                    exact
                    path="/auction/:action"
                    component={AuctionLots}
                />
                <PrivateRoute exact path="/payment" component={Payment} />
                <PrivateRoute exact path="/wallet" component={Wallet} />
                <PrivateRoute exact path="/report" component={Report} />
                <PrivateRoute
                    exact
                    path="/listing/:action"
                    component={Listing}
                />
                <PrivateRoute
                    exact
                    path="/listing/draft/:secondparam"
                    component={DraftListing}
                />
                <PrivateRoute
                    exact
                    path="/syncinventory"
                    component={Syncinventory}
                />
                <PrivateRoute
                    exact
                    path="/agency/:action"
                    component={AgencyView}
                />
                <PrivateRoute
                    exact
                    path="/agency/users/all"
                    component={AllAgencyUsers}
                />
                <PrivateRoute
                    exact
                    path="/agency/payment"
                    component={AgencyPayment}
                />
                <PrivateRoute
                    exact
                    path="/templates/auction"
                    component={AuctionTemplates}
                />
                <PrivateRoute
                    exact
                    path="/templates/listing"
                    component={ProductTemplates}
                />
                <PrivateRoute
                    exact
                    path="/buyers/:action"
                    component={UserView}
                />
                <Route
                    exact
                    path="/users/:status/:id"
                    component={BuyerFields}
                />
                <PrivateRoute exact path="/employees" component={Employee} />
                <PrivateRoute
                    exact
                    path="/communications/logs/:action"
                    component={Logs}
                />
                <PrivateRoute
                    exact
                    path="/communications/:action"
                    component={TemplateView}
                />
                <PrivateRoute
                    exact
                    path="/languageManager"
                    component={LanguageManager}
                />
                <PrivateRoute exact path="/store/themes" component={Theme} />
                <PrivateRoute
                    exact
                    path="/store/configuration"
                    component={Theme}
                />
                {/* <PrivateRoute
                    exact
                    path="/invoice/:action"
                    component={Invoice}
                /> */}
                <PrivateRoute exact path="/invoice/:action">
                    <Invoice
                        from={'invoice'}
                        full_payment={true}
                        paymentMode={
                            user && user.emp_type == 'super_admin'
                                ? [
                                      { value: 'offline', show: 'Offline' },
                                      { value: 'card', show: 'Online' },
                                  ]
                                : [{ value: 'offline', show: 'Offline' }]
                        }
                    />
                </PrivateRoute>
                <PrivateRoute
                    exact
                    path="/billing/:action"
                    component={MyInvoice}
                />
                <PrivateRoute
                    exact
                    path="/ordercontrol/:action"
                    component={Order}
                />
                <PrivateRoute
                    exact
                    path="/settings/static"
                    component={StaticView}
                />
                <PrivateRoute
                    exact
                    path="/settings/general"
                    component={ConfigView}
                />
                <PrivateRoute
                    exact
                    path="/settings/maintanence"
                    component={MaintanenceManage}
                />
                <PrivateRoute
                    exact
                    path="/settings/category"
                    component={Category}
                />
                <PrivateRoute
                    exact
                    path="/settings/condition"
                    component={Condition}
                />
                <PrivateRoute
                    exact
                    path="/settings/headermenus"
                    component={HeaderMenu}
                />
                <PrivateRoute exact path="/erp" component={ERP} />
                <PrivateRoute
                    exact
                    path="/erp/inventory"
                    component={ERP}
                    // component={InventoryErp}
                />
                <PrivateRoute exact path="/erp/manifest" component={Manifest} />
                <PrivateRoute
                    exact
                    path="/settings/location"
                    component={Location}
                />
                <PrivateRoute exact path="/locations" component={Location} />
                <PrivateRoute exact path="/return/:action" component={Return} />
                <PrivateRoute
                    exact
                    path="/member"
                    component={MemberItemLookUp}
                />
                <PrivateRoute
                    exact
                    path="/settings/bid_increments"
                    component={BidIncrement}
                />
                <PrivateRoute
                    exact
                    path="/transaction/payment"
                    component={TransactionPayment}
                />
                <PrivateRoute
                    exact
                    path="/transaction/refund"
                    component={TransactionRefund}
                />
                <PrivateRoute exact path="/org/:action" component={OrgView} />
                <PrivateRoute
                    exact
                    path="/campaign/create"
                    component={CreateCampaign}
                />
                <PrivateRoute
                    exact
                    path="/campaign/template"
                    component={EmailTemplate}
                />
                <PrivateRoute exact path="/messages" component={Message} />
                <PrivateRoute
                    exact
                    path="/inventory/:action"
                    component={Inventory}
                />
                <PrivateRoute
                    exact
                    path="/bid_deposit"
                    component={BidDeposit}
                />
                <PrivateRoute
                    exact
                    path="/videoAuction/broadcast"
                    component={BroadCaster}
                />
                <PrivateRoute
                    exact
                    path="/billing/:type/:id"
                    component={BillingInfo}
                />
                <PrivateRoute exact path="/onboarding" component={PayOut} />
                <PrivateRoute
                    exact
                    path="/onboard_response"
                    component={StripeStatusCheck}
                />
                {/* <PrivateRoute
                    exact
                    path="/payments/saved_cards"
                    component={MyCard}
                /> */}
                <PrivateRoute
                    exact
                    path="/videoAuction/live_auction"
                    component={LiveAuction}
                />
                <PrivateRoute
                    exact
                    path="/ui_settings"
                    component={SettingsUI}
                />
                <PrivateRoute
                    exact
                    path="/dynamic/pages"
                    component={DynamicPage}
                />
                <PrivateRoute
                    exact
                    path="/dynamic/table/pages"
                    component={DynamicTablePages}
                />
                <PrivateRoute
                    exact
                    path="/appointment/:action"
                    component={Appointment}
                />
                <PrivateRoute
                    exact
                    path="/erp/auction/:action"
                    component={ERP}
                />
                <Route exact path="/erp/:id" component={ERP} />
                <PrivateRoute
                    exact
                    path="/subscribers"
                    component={SubscribeData}
                />
                {/* <PrivateRoute
                    exact
                    path="/settings/tax_code"
                    component={TaxCodeList}
                /> */}
                <PrivateRoute
                    exact
                    path="/settings/tax_table"
                    component={TaxTable}
                />
                <PrivateRoute
                    exact
                    path="/settings/palletPricing"
                    component={PalletPricing}
                />
                <PrivateRoute exact path="/plugins" component={Plugins} />
                <PrivateRoute exact path="/settings/banner">
                    <BannerImage
                        extraBannerFields={extraBannerFields}
                        includeVideo={true}
                    />
                </PrivateRoute>
                <PrivateRoute
                    exact
                    path="/settings/twoFactor"
                    component={TwoFactor}
                />
                <PrivateRoute exact path="/add/user/new" component={UserAdd} />
                <PrivateRoute
                    exact
                    path="/questions_answers"
                    component={QuestionAnswer}
                />
                <Route
                    exact
                    path="/listing/edit/:id"
                    render={(props) => (
                        <EditListing
                            {...props}
                            seller={true}
                            delete_bid={true}
                        />
                    )}
                />
                <Route
                    exact
                    path="/listing/:status/:id"
                    render={(props) => (
                        <ListingManage {...props} seller={true} />
                    )}
                />
                <Route
                    exact
                    path="/auction/:status/:id"
                    component={AuctionListing}
                />
                <Route
                    exact
                    path="/invoice/view/:action/:id/:uid"
                    component={InvoiceView}
                />
                <Route exact path="/invoice/payment/:id/:uid">
                    <PaymentManage
                        from={'invoice'}
                        data={{ id: 0, sid: 0, status: 'edit' }}
                        full_payment={true}
                        defaultCountry
                        paymentMode={
                            user && user.emp_type == 'super_admin'
                                ? [
                                      { value: 'offline', show: 'Offline' },
                                      { value: 'card', show: 'Online' },
                                  ]
                                : [{ value: 'offline', show: 'Offline' }]
                        }
                    />
                </Route>
                <Route
                    exact
                    path="/employees/edit/:eid"
                    component={EmployeeEdit}
                />
                <Route
                    exact
                    path="/templates/listing/:status/:id"
                    component={ProductTemplateManage}
                />
                <Route
                    exact
                    path="/templates/auction/:status/:id"
                    component={AuctionTemplateManage}
                />
                <Route
                    exact
                    path="/questions_answers/:id/:productId"
                    component={ManageComments}
                />
                <Route
                    exact
                    path="/employees/new/:eid"
                    component={EmployeeManage}
                />
                <Route
                    exact
                    path="/return/view/:id/:uid"
                    component={ReturnView}
                />
                <Route exact path="/seller/:status/:id" component={OrgManage} />
                <Route exact path="/user/:status/:id" component={BuyerFields} />
                <Route exact path="/noAccess" noAuth={true}>
                    <NotFound noAuth={true} />
                </Route>
                <Route exact path="*" component={NotFound} />
            </Switch>
        </>
    )
}
export default withRouter(Routes)
